import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useResizeObserver } from '@isyc-react/core/resize-observer';
export const useOverflowObserver = ref => {
  const {
    height,
    width
  } = useResizeObserver({
    ref
  });
  const [overflowX, setOverflowX] = React.useState(undefined);
  const [overflowY, setOverflowY] = React.useState(undefined);
  React.useEffect(() => {
    if (height && ref !== null && ref !== void 0 && ref.current) {
      setOverflowY(ref.current.scrollHeight > ref.current.clientHeight);
    }
  }, [height]);
  React.useEffect(() => {
    if (width && ref !== null && ref !== void 0 && ref.current) {
      setOverflowX(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [width]);
  return {
    overflowX,
    overflowY,
    height,
    width
  };
};